import AxiosInstance from 'src/shared/services/axios/interceptor';
import { Member } from 'src/modules/member/models/member';
import { MemberPost } from 'src/modules/member/models/memberPost';
import { PagedResult } from 'src/shared/models/pagedResult';
import { setPagingParams } from 'src/shared/functions/createPagingParams';
import { MemberFormSettings } from 'src/modules/member/models/memberFormSettings';
import { MemberProfilePost } from 'src/modules/member/models/memberProfilePost';
import { MembersByMonth } from 'src/modules/dashboard/models/memberByMonth';
import { MemberStats } from 'src/modules/dashboard/models/memberStats';
import { MemberSearchFilter } from 'src/modules/member/models/memberSearchFilter';
import { PaymentMethodInUse } from 'src/modules/member/models/paymentMethodInUse';
import { ResignMemberRequest } from 'src/modules/member/models/resignMemberRequest';
import { InvoiceAddressRequest } from 'src/modules/member/invoicerecipient/models/invoiceAddressRequest';
import { EnterMemberRequest } from 'src/modules/member/models/enterMemberRequest';
import { ChangeAssociationRequest } from 'src/modules/member/models/changeAssocationRequest';
import { AutogiroMandateConnectMemberRequest } from 'src/modules/member/models/autogiroMandateConnectMemberRequest';
import { MemberEmail } from 'src/modules/member/models/memberEmail';
import { MemberEmailSearchFilter } from 'src/modules/invoice/models/memberEmailSearchFilter';
import ConsoleHelper from '../functions/consoleHelper';
import { setArrayValue } from '../functions/setArrayValue';
import { KivraLookupSearchFilter } from '../models/kivra/kivraLookupSearchfilter';
import { InvoiceSendingTypeIntegerEnum } from '../models/enums/invoiceSendingTypeInteger.enum';

const controller = 'Member';
const formController = 'Form';

export const getMembers = (
  pageIndex,
  pageSize,
  sortCol,
  sortDir,
  searchFilter: MemberSearchFilter,
  exportProperties: Array<string>,
  exportFormat,
) => {
  ConsoleHelper.log('searchFilter', searchFilter);

  // const setArrayValue = (searchFilterProp, queryName) => {
  //   let result = '';
  //   if (searchFilterProp && searchFilterProp.length > 0) {
  //     searchFilterProp.forEach((x) => {
  //       result += x ? `&${queryName}=${x}` : '';
  //     });
  //   }
  //   return result;
  // };

  let extraQuery = '';
  extraQuery += searchFilter.selectionId ? `&selectionId=${searchFilter.selectionId}` : '';
  extraQuery += searchFilter.groupName ? `&groupName=${searchFilter.groupName}` : '';
  extraQuery += searchFilter.searchString ? `&filter=${searchFilter.searchString}` : '';
  extraQuery += searchFilter.memberNr ? `&memberNr=${searchFilter.memberNr}` : '';
  extraQuery += searchFilter.countyCode ? `&countyCode=${searchFilter.countyCode}` : '';
  extraQuery += searchFilter.municipalityCode ? `&municipalityCode=${searchFilter.municipalityCode}` : '';
  extraQuery += searchFilter.postCode ? `&postCode=${searchFilter.postCode}` : '';
  extraQuery += searchFilter.firstName ? `&firstName=${searchFilter.firstName}` : '';
  extraQuery += searchFilter.lastName ? `&lastName=${searchFilter.lastName}` : '';
  extraQuery += searchFilter.pnr ? `&pnr=${searchFilter.pnr}` : '';
  extraQuery += searchFilter.co ? `&co=${searchFilter.co}` : '';
  extraQuery += searchFilter.country ? `&country=${searchFilter.country}` : '';
  extraQuery += searchFilter.email ? `&email=${searchFilter.email}` : '';
  extraQuery += searchFilter.phone ? `&phone=${searchFilter.phone}` : '';
  extraQuery += searchFilter.phoneOther ? `&phoneOther=${searchFilter.phoneOther}` : '';
  extraQuery += searchFilter.address ? `&address=${searchFilter.address}` : '';
  extraQuery += searchFilter.addressOther ? `&addressOther=${searchFilter.addressOther}` : '';
  extraQuery += searchFilter.city ? `&city=${searchFilter.city}` : '';
  extraQuery += searchFilter.custom1 ? `&custom1=${searchFilter.custom1}` : '';
  extraQuery += searchFilter.custom2 ? `&custom2=${searchFilter.custom2}` : '';
  extraQuery += searchFilter.custom3 ? `&custom3=${searchFilter.custom3}` : '';
  extraQuery += searchFilter.custom4 ? `&custom4=${searchFilter.custom4}` : '';
  extraQuery += searchFilter.custom5 ? `&custom5=${searchFilter.custom5}` : '';
  extraQuery += searchFilter.custom6 ? `&custom6=${searchFilter.custom6}` : '';
  extraQuery += searchFilter.custom7 ? `&custom7=${searchFilter.custom7}` : '';
  extraQuery += searchFilter.custom8 ? `&custom8=${searchFilter.custom8}` : '';
  extraQuery += searchFilter.custom9 ? `&custom9=${searchFilter.custom9}` : '';
  extraQuery += searchFilter.custom10 ? `&custom10=${searchFilter.custom10}` : '';
  extraQuery += searchFilter.newspaper ? `&newspaper=${searchFilter.newspaper}` : '';

  extraQuery += setArrayValue(searchFilter.status, 'status');
  extraQuery += setArrayValue(searchFilter.paymentMethods, 'paymentMethods');
  extraQuery += setArrayValue(searchFilter.profileItemIds, 'profileItemIds');
  extraQuery += setArrayValue(searchFilter.excludedProfileItemIds, 'excludedProfileItemIds');
  extraQuery += searchFilter.associationId ? `&associationId=${searchFilter.associationId}` : '';
  extraQuery += setArrayValue(searchFilter.associationIds, 'associationIds');
  extraQuery += setArrayValue(searchFilter.districtIds, 'districtIds');

  extraQuery += searchFilter.admDateStart ? `&admDateStart=${searchFilter.admDateStart}` : '';
  extraQuery += searchFilter.admDateEnd ? `&admDateEnd=${searchFilter.admDateEnd}` : '';
  extraQuery += searchFilter.resDateStart ? `&resDateStart=${searchFilter.resDateStart}` : '';
  extraQuery += searchFilter.resDateEnd ? `&resDateEnd=${searchFilter.resDateEnd}` : '';
  extraQuery += searchFilter.dueDateStart ? `&dueDateStart=${searchFilter.dueDateStart}` : '';
  extraQuery += searchFilter.dueDateEnd ? `&dueDateEnd=${searchFilter.dueDateEnd}` : '';
  extraQuery += searchFilter.payDateStart ? `&payDateStart=${searchFilter.payDateStart}` : '';
  extraQuery += searchFilter.payDateEnd ? `&payDateEnd=${searchFilter.payDateEnd}` : '';
  extraQuery += searchFilter.birthDateStart ? `&birthDateStart=${searchFilter.birthDateStart}` : '';
  extraQuery += searchFilter.birthDateEnd ? `&birthDateEnd=${searchFilter.birthDateEnd}` : '';

  extraQuery += searchFilter.hasMobilePhone ? `&hasMobilePhone=${searchFilter.hasMobilePhone}` : '';
  extraQuery += searchFilter.hasEmailAddress ? `&hasEmailAddress=${searchFilter.hasEmailAddress}` : '';
  extraQuery += searchFilter.hasNewspaper ? `&hasNewspaper=${searchFilter.hasNewspaper}` : '';
  extraQuery += searchFilter.isMainMember ? `&isMainMember=${searchFilter.isMainMember}` : '';
  extraQuery += searchFilter.isFamilyMember ? `&isFamilyMember=${searchFilter.isFamilyMember}` : '';
  extraQuery += searchFilter.hasFamily ? `&hasFamily=${searchFilter.hasFamily}` : '';
  extraQuery += searchFilter.excludeMemberId ? `&excludeMemberId=${searchFilter.excludeMemberId}` : '';
  extraQuery += searchFilter.excludeMembersWithoutEmail ? `&excludeMembersWithoutEmail=${searchFilter.excludeMembersWithoutEmail}` : '';

  extraQuery += searchFilter.resCause ? `&resCause=${searchFilter.resCause}` : '';
  extraQuery += searchFilter.sex ? `&sex=${searchFilter.sex}` : '';
  extraQuery += searchFilter.otherContact ? `&other=${searchFilter.otherContact}` : '';

  extraQuery += setArrayValue(searchFilter.titleIds, 'titleIds');
  extraQuery += searchFilter.includeResignedTitles ? `&includeResignedTitles=${searchFilter.includeResignedTitles}` : '';

  extraQuery += exportFormat ? `&exportFormat=${exportFormat}` : '';
  extraQuery += setArrayValue(exportProperties, 'exportProperties');

  const endpoint = `${controller}/?${setPagingParams({
    pageIndex,
    pageSize,
    sortCol,
    sortDir,
  })}${extraQuery}`;
  return AxiosInstance.get<PagedResult<Member>>(endpoint);
};

export const getOtherMembers = (other, filter) => {
  const pageIndex = 0;
  const pageSize = 500;
  const sortCol = 'firstName';
  const sortDir = 'ASC';
  const endpoint = `${controller}/?${setPagingParams({
    pageIndex,
    pageSize,
    sortCol,
    sortDir,
  })}${other && '&other=true'}&filter=${filter}`;
  return AxiosInstance.get<PagedResult<Member>>(endpoint);
};

export const getMemberSettings = () => {
  const endpoint = `${controller}/me`;
  return AxiosInstance.get<Member>(endpoint);
};
export const getNextExpireDateMember = (memberId: number) => {
  const endpoint = `${controller}/${memberId}/NextExpireDate`;
  return AxiosInstance.get<string>(endpoint);
};

export const getMembersBySelectionId = (selectionId) => {
  const endpoint = `${controller}/?selectionId=${selectionId}`;
  return AxiosInstance.get<Selection>(endpoint);
};

// Distinkta betalmetod+periodicitet-kombinationer som minst en medlem använder (för filtret i utökad sök).
export const getPaymentMethodsInUse = () => {
  return AxiosInstance.get<PaymentMethodInUse[]>(`${controller}/PaymentMethodsInUse`);
};

export const getMembersByGroupName = (groupName) => {
  const endpoint = `${controller}/?groupName=${groupName}`;
  return AxiosInstance.get<Selection>(endpoint);
};

export const getMemberById = (id) => {
  const endpoint = `${controller}/${id}`;
  return AxiosInstance.get<Member>(endpoint);
};
export const getMemberCard = (id) => {
  const endpoint = `${controller}/${id}/MemberCard`;
  return AxiosInstance.get<string>(endpoint);
};

export const getUnsubscribeToken = (id: number) => {
  return AxiosInstance.get<{ url: string }>(`${controller}/${id}/UnsubscribeToken`);
};

export const updateMember = (member: Member) => {
  const endpoint = `${controller}`;
  return AxiosInstance.put<Member>(endpoint, member);
};

export const createMember = (member: MemberPost) => {
  const endpoint = `${controller}`;
  return AxiosInstance.post<MemberPost>(endpoint, member);
};

export const createMemberProfile = (memberId: number, memberProfilePost: MemberProfilePost) => {
  const endpoint = `${controller}/${memberId}/Profile`;
  return AxiosInstance.post<MemberPost>(endpoint, memberProfilePost);
};

export const deleteMemberProfile = (memberId: number, memberProfileItemId: string) => {
  const endpoint = `${controller}/${memberId}/Profile`;
  return AxiosInstance.delete<MemberPost>(endpoint, { data: { memberProfileItem_id: memberProfileItemId } });
};

export const getMemberFormSettings = (id) => {
  const endpoint = `${formController}/${id}`;
  return AxiosInstance.get<MemberFormSettings>(endpoint);
};

export const getFormSettings = () => {
  const endpoint = `${formController}`;
  return AxiosInstance.get<MemberFormSettings>(endpoint);
};

export const getCountMembersByMonth = (startDate: string, endDate: string, associationId, districtId) => {
  let extraQuery = '';
  extraQuery += startDate ? `&startDate=${startDate}` : '';
  extraQuery += endDate ? `&endDate=${endDate}` : '';
  extraQuery += associationId ? `&associationId=${associationId}` : '';
  extraQuery += districtId ? `&districtId=${districtId}` : '';
  const endpoint = `${controller}/CountMembersByMonth?${extraQuery.substring(1)}`;
  return AxiosInstance.get<MembersByMonth[]>(endpoint);
};

export const getMemberStats = (associationId, districtId) => {
  let extraQuery = '';
  extraQuery += associationId ? `&associationId=${associationId}` : '';
  extraQuery += districtId ? `&districtId=${districtId}` : '';
  const endpoint = `${controller}/Stats?${extraQuery.substring(1)}`;
  return AxiosInstance.get<MemberStats>(endpoint);
};

export const updateResignMember = (memberId: number, req: ResignMemberRequest) => {
  const endpoint = `${controller}/${memberId}/Resign`;
  return AxiosInstance.put<ResignMemberRequest>(endpoint, req);
};
export const updateReenterMember = (memberId: number) => {
  const endpoint = `${controller}/${memberId}/Reenter`;
  return AxiosInstance.put(endpoint);
};

export const updateEnterMember = (memberId: number, req: EnterMemberRequest) => {
  const endpoint = `${controller}/${memberId}/Enter`;
  return AxiosInstance.put<EnterMemberRequest>(endpoint, req);
};

export const createInvoiceAddressOnMember = (memberId: number, req: InvoiceAddressRequest) => {
  const endpoint = `${controller}/${memberId}/InvoiceAddress`;
  return AxiosInstance.post<{ id: number }>(endpoint, req);
};

export const updateInvoiceAddressOnMember = (memberId: number, req: InvoiceAddressRequest) => {
  const endpoint = `${controller}/${memberId}/InvoiceAddress`;
  return AxiosInstance.put<{ id: number }>(endpoint, req);
};

export const changeMemberAssociation = (memberId: number, req: ChangeAssociationRequest) => {
  const endpoint = `${controller}/${memberId}/ChangeAssociation`;
  return AxiosInstance.put<{ id: number }>(endpoint, req);
};

export const addAutogiroMandate = (memberId: number, req: AutogiroMandateConnectMemberRequest) => {
  const endpoint = `${controller}/${memberId}/AutogiroMandate`;
  return AxiosInstance.put<{ id: number }>(endpoint, req);
};

export const getMemberEmailLog = (memberId: number, searchFilter: MemberEmailSearchFilter) => {
  return AxiosInstance.get<PagedResult<MemberEmail>>(`${controller}/${memberId}/Email`, { params: searchFilter });
};

export const getMembersWithKivraByInvoiceMissionId = (
  invoiceMissionId: number,
  sendingType: InvoiceSendingTypeIntegerEnum,
  searchFilter: KivraLookupSearchFilter,
) => {
  const endpoint = `${controller}/KivraLookup/${invoiceMissionId}/${sendingType}`;
  return AxiosInstance.get<PagedResult<Member>>(endpoint, {
    params: searchFilter,
  });
};
